webpackJsonp([1,4],{

/***/ "/fcW":
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "/fcW";


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("x35b");


/***/ }),

/***/ "1A80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__ = __webpack_require__("l0Vc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_app_component__ = __webpack_require__("YWx4");
/* unused harmony export RenderType_AppComponent */
/* unused harmony export View_AppComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_AppComponent = [__WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AppComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_24" /* ɵcrt */]({
    encapsulation: 0,
    styles: styles_AppComponent,
    data: {}
});
function View_AppComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 22, 'header', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'h1', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    Extreme Pingpong\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 16, 'div', [[
                'class',
                'info'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'span', [[
                'class',
                'info__item'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      Author: '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '',
            ''
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'span', [[
                'class',
                'info__item'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      Version: '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '',
            ''
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'a', [
            [
                'class',
                'info__item'
            ],
            [
                'target',
                '_blank'
            ]
        ], [[
                8,
                'href',
                4
            ]
        ], null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n\n      Github\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'content', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](8388608, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](73728, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_router__["y" /* RouterOutlet */], [
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["l" /* RouterOutletMap */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["W" /* ComponentFactoryResolver */],
            [
                8,
                null
            ]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n']))
    ], null, function (ck, v) {
        var co = v.component;
        var currVal_0 = co.projectAuthor;
        ck(v, 10, 0, currVal_0);
        var currVal_1 = co.projectVersion;
        ck(v, 16, 0, currVal_1);
        var currVal_2 = co.githubRepositoryUrl;
        ck(v, 19, 0, currVal_2);
    });
}
function View_AppComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'ept-root', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](57344, null, 0, __WEBPACK_IMPORTED_MODULE_3__app_app_component__["a" /* AppComponent */], [], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var AppComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_29" /* ɵccf */]('ept-root', __WEBPACK_IMPORTED_MODULE_3__app_app_component__["a" /* AppComponent */], View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvUGVkcm8tdmsvZXh0cmVtZS1waW5ncG9uZy10b3VybmFtZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGhlYWRlcj5cbiAgPGgxPlxuICAgIEV4dHJlbWUgUGluZ3BvbmdcbiAgPC9oMT5cbiAgPGRpdiBjbGFzcz1cImluZm9cIj5cbiAgICA8c3BhbiBjbGFzcz1cImluZm9fX2l0ZW1cIj5cbiAgICAgIEF1dGhvcjogPHNwYW4+e3twcm9qZWN0QXV0aG9yfX08L3NwYW4+XG4gICAgPC9zcGFuPlxuICAgIDxzcGFuIGNsYXNzPVwiaW5mb19faXRlbVwiPlxuICAgICAgVmVyc2lvbjogPHNwYW4+e3twcm9qZWN0VmVyc2lvbn19PC9zcGFuPlxuICAgIDwvc3Bhbj5cbiAgICA8YVxuICAgICAgY2xhc3M9XCJpbmZvX19pdGVtXCJcbiAgICAgIHRhcmdldD1cIl9ibGFua1wiXG4gICAgICBbaHJlZl09XCJnaXRodWJSZXBvc2l0b3J5VXJsXCI+XG5cbiAgICAgIEdpdGh1YlxuICAgIDwvYT5cbiAgPC9kaXY+XG48L2hlYWRlcj5cbjxjb250ZW50PlxuICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48L2NvbnRlbnQ+XG4iLCI8ZXB0LXJvb3Q+PC9lcHQtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUFRO0lBQ047SUFBSTtJQUVDO01BQ0w7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrQjtNQUNoQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlCO0lBQ2Y7SUFBTTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQXdCO0lBQ2pDO01BQ1A7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QjtJQUNkO0lBQU07TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUF5QjtJQUNuQztJQUNQO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHK0I7SUFHM0I7SUFDQTtJQUNDO0lBQ1Q7SUFBUztJQUNQO2dCQUFBOzs7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUErQjtJQUN2Qjs7OztJQWhCVTtJQUFBO0lBR0M7SUFBQTtJQUtmO0lBSEYsVUFHRSxTQUhGOzs7OztJQ1hKO2dCQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=app.component.ngfactory.js.map

/***/ }),

/***/ "3pbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__ = __webpack_require__("owqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__ = __webpack_require__("KhQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngrx_store_localstorage__ = __webpack_require__("62z6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngrx_store_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ngrx_store_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__ = __webpack_require__("W7JY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__environments_environment__ = __webpack_require__("kZql");
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* unused harmony export getPlayersState */
/* unused harmony export getPlayerEntities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPlayersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPlayersByVictories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMaxVictories; });
/* unused harmony export getQueue */
/* unused harmony export getPlaying */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQueuePlayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPlayingPlayers; });







// Reducers
var reducers = {
    players: __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["a" /* reducer */],
};
var localStorageSyncConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ngrx_store_localstorage__["localStorageSync"])(['players'], true);
var developmentReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__["compose"])(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__["storeFreeze"], localStorageSyncConfig, __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["a" /* combineReducers */])(reducers);
var productionReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__["compose"])(localStorageSyncConfig, __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["a" /* combineReducers */])(reducers);
function reducer(state, action) {
    if (__WEBPACK_IMPORTED_MODULE_6__environments_environment__["a" /* environment */].production) {
        return productionReducer(state, action);
    }
    else {
        return developmentReducer(state, action);
    }
}
// Store selectors
// Players
var getPlayersState = function (state) { return state.players; };
var getPlayerEntities = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["b" /* getPlayerEntities */]);
var getPlayersList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["c" /* getPlayers */]);
var getPlayersByVictories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["d" /* getPlayersByVictories */]);
var getMaxVictories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersList, function (players) {
    return players
        .reduce(function (acc, player) { return Math.max(acc, player.victories); }, 0);
});
// Queue
var getQueue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["e" /* getQueue */]);
var getPlaying = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["f" /* getPlaying */]);
var isPlaying = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlayersState, __WEBPACK_IMPORTED_MODULE_5__players_queue_reducer__["g" /* isPlaying */]);
// Player + Queue
var getQueuePlayers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getQueue, getPlayerEntities, function (queue, players) {
    return queue.map(function (id) { return players[id]; });
});
var getPlayingPlayers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(getPlaying, getPlayerEntities, function (playing, players) {
    return playing.map(function (id) { return players[id]; });
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "4CF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_take__ = __webpack_require__("hzF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_queue_actions__ = __webpack_require__("aJWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__("3pbj");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var GameComponent = (function () {
    function GameComponent(store) {
        this.store = store;
    }
    GameComponent.prototype.ngOnInit = function () {
        var livesToArray = function (players) {
            return players
                .filter(function (_) { return _; })
                .map(function (player) { return (__assign({}, player, { livesList: Array(player.lives).fill(true).concat(Array(player.initialLives - player.lives).fill(false)) })); });
        };
        this.leaderboard = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["c" /* getPlayersByVictories */])
            .map(livesToArray);
        this.playing = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["d" /* getPlayingPlayers */])
            .map(livesToArray);
        this.queue = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["e" /* getQueuePlayers */]);
        this.isPlaying = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["f" /* isPlaying */]);
        this.maxVictories = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["g" /* getMaxVictories */]);
    };
    GameComponent.prototype.matchFinished = function (winner, loser) {
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_3__actions_queue_actions__["c" /* ResultAction */](winner, loser));
    };
    GameComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["b" /* Store */] }]; };
    return GameComponent;
}());

//# sourceMappingURL=game.component.js.map

/***/ }),

/***/ "6ruF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tournament_component__ = __webpack_require__("XXEX");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__tournament_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__players_players_component__ = __webpack_require__("B4B6");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__players_players_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_game_component__ = __webpack_require__("4CF+");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__game_game_component__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {
	"name": "extreme-pingpong-tournament",
	"version": "0.2.0",
	"description": "Extreme Pingpong tournament",
	"license": "MIT",
	"private": true,
	"author": "Pedro Gutiérrez <info@xitrus.es> (http://xitrus.es)",
	"homepage": "extreme-pingpong.xitrus.es",
	"repository": {
		"type": "git",
		"url": "https://github.com/Pedro-vk/extreme-pingpong-tournament"
	},
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"prebuild": "npm run clean",
		"build": "ng build --aot --sourcemap --prod",
		"postbuild": "npm run cache",
		"test": "ng test --single-run --code-coverage",
		"lint": "ng lint",
		"e2e": "ng e2e",
		"clean": "rm -rf ./dist/",
		"cache": "sw-precache --config=src/sw-precache.config.js --root=dist",
		"create-cname": "echo $(cat package.json | grep '\"homepage\"' | cut -d '\"' -f 4) > dist/CNAME",
		"heroku": "cp -fr ./.heroku/. ./dist",
		"gh-pages-travis": "npm run create-cname && npm run heroku && gh-pages-travis"
	},
	"dependencies": {
		"@angular/common": ">=4.0.0-beta <5.0.0",
		"@angular/compiler": ">=4.0.0-beta <5.0.0",
		"@angular/core": ">=4.0.0-beta <5.0.0",
		"@angular/forms": ">=4.0.0-beta <5.0.0",
		"@angular/http": ">=4.0.0-beta <5.0.0",
		"@angular/platform-browser": ">=4.0.0-beta <5.0.0",
		"@angular/platform-browser-dynamic": ">=4.0.0-beta <5.0.0",
		"@angular/router": ">=4.0.0-beta <5.0.0",
		"@ngrx/core": "^1.2.0",
		"@ngrx/store": "^2.2.1",
		"@ngrx/store-devtools": "^3.2.3",
		"core-js": "^2.4.1",
		"ngrx-store-freeze": "^0.1.9",
		"ngrx-store-localstorage": "^0.1.5",
		"reselect": "^3.0.0",
		"rxjs": "^5.1.0",
		"zone.js": "^0.8.4"
	},
	"devDependencies": {
		"@angular/cli": "^1.0.0",
		"@angular/compiler-cli": ">=4.0.0-beta <5.0.0",
		"@types/jasmine": "2.5.47",
		"@types/node": "~7.0.8",
		"codelyzer": "~3.0.0-beta.3",
		"gh-pages-travis": "^1.0.4",
		"jasmine-core": "~2.5.2",
		"jasmine-spec-reporter": "~4.0.0",
		"karma": "~1.6.0",
		"karma-chrome-launcher": "~2.0.0",
		"karma-cli": "~1.0.1",
		"karma-coverage-istanbul-reporter": "^1.0.0",
		"karma-coveralls": "^1.1.2",
		"karma-jasmine": "~1.1.0",
		"karma-jasmine-html-reporter": "^0.2.2",
		"karma-phantomjs-launcher": "1.0.4",
		"phantomjs": "^2.1.7",
		"protractor": "~5.1.0",
		"sw-precache": "^5.1.0",
		"ts-node": "~3.0.2",
		"tslint": "~5.1.0",
		"typescript": "~2.2.1"
	}
};

/***/ }),

/***/ "B4B6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_players_actions__ = __webpack_require__("I003");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_queue_actions__ = __webpack_require__("aJWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__("3pbj");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayersComponent; });




var PlayersComponent = (function () {
    function PlayersComponent(store) {
        this.store = store;
    }
    PlayersComponent.prototype.ngOnInit = function () {
        this.players = this.store
            .select(__WEBPACK_IMPORTED_MODULE_3__reducers__["b" /* getPlayersList */]);
    };
    PlayersComponent.prototype.add = function (name) {
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_1__actions_players_actions__["b" /* AddAction */]({ name: name, id: Math.random().toString(36).substr(2, 10) }));
        this.resetUsers();
    };
    PlayersComponent.prototype.remove = function (player) {
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_1__actions_players_actions__["c" /* RemoveAction */](player));
        this.resetUsers();
    };
    PlayersComponent.prototype.trackById = function (index, object) {
        return object.id || undefined;
    };
    PlayersComponent.prototype.resetUsers = function () {
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_2__actions_queue_actions__["b" /* ShuffleAction */]());
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_1__actions_players_actions__["d" /* ResetLivesAction */](3));
    };
    PlayersComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["b" /* Store */] }]; };
    return PlayersComponent;
}());

//# sourceMappingURL=players.component.js.map

/***/ }),

/***/ "Cd9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tournament__ = __webpack_require__("6ruF");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });

var routes = [
    { path: '', component: __WEBPACK_IMPORTED_MODULE_0__tournament__["a" /* TournamentComponent */], children: [
            { path: '', component: __WEBPACK_IMPORTED_MODULE_0__tournament__["b" /* GameComponent */] },
            { path: 'players', component: __WEBPACK_IMPORTED_MODULE_0__tournament__["c" /* PlayersComponent */] },
        ] },
    { path: '**', redirectTo: '' },
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());

//# sourceMappingURL=app-routing.module.js.map

/***/ }),

/***/ "FC2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__game_component_scss_shim_ngstyle__ = __webpack_require__("SRum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_tournament_game_game_component__ = __webpack_require__("4CF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngrx_store_src_store__ = __webpack_require__("Zcpd");
/* unused harmony export RenderType_GameComponent */
/* unused harmony export View_GameComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_GameComponent = [__WEBPACK_IMPORTED_MODULE_0__game_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_GameComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_24" /* ɵcrt */]({
    encapsulation: 0,
    styles: styles_GameComponent,
    data: {}
});
function View_GameComponent_3(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n          ',
            '\n        '
        ]))
    ], null, function (ck, v) {
        var currVal_0 = (v.context.$implicit ? 'favorite' : 'favorite_border');
        ck(v, 1, 0, currVal_0);
    });
}
function View_GameComponent_2(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 22, 'div', [], [[
                8,
                'className',
                0
            ]
        ], null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'name'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n        ',
            '\n      '
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'div', [[
                'class',
                'victories'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n        '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['whatshot'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n        ',
            '\n      '
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'div', [[
                'class',
                'lives'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n        '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 1, null, View_GameComponent_3)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], { ngForOf: [
                0,
                'ngForOf'
            ]
        }, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'div', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n        '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'button', [], null, [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            var co = v.component;
            if (('click' === en)) {
                var pd_0 = (co.matchFinished(v.context.$implicit, v.context.ngForOf[(1 - v.context.index)]) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Winner!'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    ']))
    ], function (ck, v) {
        var currVal_3 = ((v.context.$implicit == null) ? null : v.context.$implicit.livesList);
        ck(v, 14, 0, currVal_3);
    }, function (ck, v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_35" /* ɵinlineInterpolate */](1, 'player player-n', v.context.index, '');
        ck(v, 0, 0, currVal_0);
        var currVal_1 = ((v.context.$implicit == null) ? null : v.context.$implicit.name);
        ck(v, 3, 0, currVal_1);
        var currVal_2 = ((v.context.$implicit == null) ? null : v.context.$implicit.victories);
        ck(v, 9, 0, currVal_2);
    });
}
function View_GameComponent_4(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'next-player'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n      ',
            '\n    '
        ]))
    ], null, function (ck, v) {
        var currVal_0 = ((v.context.$implicit == null) ? null : v.context.$implicit.name);
        ck(v, 1, 0, currVal_0);
    });
}
function View_GameComponent_1(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 21, 'div', [[
                'class',
                'game'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 8, 'div', [[
                'class',
                'playing'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_2)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], {
            ngForOf: [
                0,
                'ngForOf'
            ],
            ngForTrackBy: [
                1,
                'ngForTrackBy'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'vs'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      .vs\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 8, 'div', [[
                'class',
                'queue'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'title'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['next'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_4)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], {
            ngForOf: [
                0,
                'ngForOf'
            ],
            ngForTrackBy: [
                1,
                'ngForTrackBy'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 5, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 6).transform(co.playing));
        var currVal_1 = ((co.player == null) ? null : co.player.id);
        ck(v, 5, 0, currVal_0, currVal_1);
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 18, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 19).transform(co.queue));
        var currVal_3 = ((co.player == null) ? null : co.player.id);
        ck(v, 18, 0, currVal_2, currVal_3);
    }, null);
}
function View_GameComponent_5(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'no-players'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  No players yet.\n']))
    ], null, null);
}
function View_GameComponent_8(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'span', [[
                'class',
                'number'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['whatshot'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    ']))
    ], null, null);
}
function View_GameComponent_9(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'span', [[
                'class',
                'number'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n      ',
            '\n    '
        ]))
    ], null, function (ck, v) {
        var currVal_0 = (v.parent.context.index + 1);
        ck(v, 1, 0, currVal_0);
    });
}
function View_GameComponent_10(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n        ',
            '\n      '
        ]))
    ], null, function (ck, v) {
        var currVal_0 = (v.context.$implicit ? 'favorite' : 'favorite_border');
        ck(v, 1, 0, currVal_0);
    });
}
function View_GameComponent_7(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 24, 'div', [[
                'class',
                'player'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_8)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_9)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'span', [[
                'class',
                'name'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n      ',
            '\n    '
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'span', [[
                'class',
                'victories'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['whatshot'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n      ',
            '\n    '
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'span', [[
                'class',
                'lives'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n      '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 1, null, View_GameComponent_10)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], { ngForOf: [
                0,
                'ngForOf'
            ]
        }, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  ']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_0 = (v.context.$implicit.victories === __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 3, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 4).transform(co.maxVictories)));
        ck(v, 3, 0, currVal_0);
        var currVal_1 = (v.context.$implicit.victories !== __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 7, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 8).transform(co.maxVictories)));
        ck(v, 7, 0, currVal_1);
        var currVal_4 = ((v.context.$implicit == null) ? null : v.context.$implicit.livesList);
        ck(v, 22, 0, currVal_4);
    }, function (ck, v) {
        var currVal_2 = ((v.context.$implicit == null) ? null : v.context.$implicit.name);
        ck(v, 11, 0, currVal_2);
        var currVal_3 = ((v.context.$implicit == null) ? null : v.context.$implicit.victories);
        ck(v, 17, 0, currVal_3);
    });
}
function View_GameComponent_6(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 8, 'div', [[
                'class',
                'leaderboard'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'title'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Leaderboard'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_7)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], {
            ngForOf: [
                0,
                'ngForOf'
            ],
            ngForTrackBy: [
                1,
                'ngForTrackBy'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 6, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 7).transform(co.leaderboard));
        var currVal_1 = ((co.player == null) ? null : co.player.id);
        ck(v, 6, 0, currVal_0, currVal_1);
    }, null);
}
function View_GameComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](2, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_1)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_5)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_GameComponent_6)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 1, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 2).transform(co.isPlaying));
        ck(v, 1, 0, currVal_0);
        var tmp_1_0 = null;
        var currVal_1 = !(((tmp_1_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 5, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 6).transform(co.leaderboard))) == null) ? null : tmp_1_0.length);
        ck(v, 5, 0, currVal_1);
        var tmp_2_0 = null;
        var currVal_2 = (((tmp_2_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 9, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 10).transform(co.leaderboard))) == null) ? null : tmp_2_0.length);
        ck(v, 9, 0, currVal_2);
    }, null);
}
function View_GameComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'ept-game', [], null, null, null, View_GameComponent_0, RenderType_GameComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](57344, null, 0, __WEBPACK_IMPORTED_MODULE_3__app_tournament_game_game_component__["a" /* GameComponent */], [__WEBPACK_IMPORTED_MODULE_4__ngrx_store_src_store__["a" /* Store */]], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var GameComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_29" /* ɵccf */]('ept-game', __WEBPACK_IMPORTED_MODULE_3__app_tournament_game_game_component__["a" /* GameComponent */], View_GameComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=game.component.ngfactory.js.map

/***/ }),

/***/ "FOiB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__players_component_scss_shim_ngstyle__ = __webpack_require__("be88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_tournament_players_players_component__ = __webpack_require__("B4B6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__("NVOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ngrx_store_src_store__ = __webpack_require__("Zcpd");
/* unused harmony export RenderType_PlayersComponent */
/* unused harmony export View_PlayersComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayersComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_PlayersComponent = [__WEBPACK_IMPORTED_MODULE_0__players_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_PlayersComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_24" /* ɵcrt */]({
    encapsulation: 0,
    styles: styles_PlayersComponent,
    data: {}
});
function View_PlayersComponent_1(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'no-players'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['No players yet.']))
    ], null, null);
}
function View_PlayersComponent_2(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 5, 'div', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, [
            '\n      ',
            '\n      '
        ])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 2, 'button', [], null, [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            var co = v.component;
            if (('click' === en)) {
                var pd_0 = (co.remove(v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'i', [[
                'class',
                'material-icons'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['delete'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    ']))
    ], null, function (ck, v) {
        var currVal_0 = v.context.$implicit.name;
        ck(v, 1, 0, currVal_0);
    });
}
function View_PlayersComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](2, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'div', [[
                'class',
                'warn'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  Any change will reset the tournament\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 30, 'div', [[
                'class',
                'align'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'h3', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Add player'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 10, 'div', [[
                'class',
                'form'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 5, 'input', [[
                'type',
                'text'
            ]
        ], [
            [
                2,
                'ng-untouched',
                null
            ],
            [
                2,
                'ng-touched',
                null
            ],
            [
                2,
                'ng-pristine',
                null
            ],
            [
                2,
                'ng-dirty',
                null
            ],
            [
                2,
                'ng-valid',
                null
            ],
            [
                2,
                'ng-invalid',
                null
            ],
            [
                2,
                'ng-pending',
                null
            ]
        ], [
            [
                null,
                'ngModelChange'
            ],
            [
                null,
                'keyup.enter'
            ],
            [
                null,
                'input'
            ],
            [
                null,
                'blur'
            ],
            [
                null,
                'compositionstart'
            ],
            [
                null,
                'compositionend'
            ]
        ], function (v, en, $event) {
            var ad = true;
            var co = v.component;
            if (('input' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 11)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 11)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 11)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((co.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (('keyup.enter' === en)) {
                co.add(co.name);
                var pd_5 = ((co.name = '') !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["d" /* DefaultValueAccessor */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["M" /* Renderer */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* ElementRef */],
            [
                2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* COMPOSITION_BUFFER_MODE */]
            ]
        ], null, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵprd */](512, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["d" /* DefaultValueAccessor */]]),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](335872, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* NgModel */], [
            [
                8,
                null
            ],
            [
                8,
                null
            ],
            [
                8,
                null
            ],
            [
                2,
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* NG_VALUE_ACCESSOR */]
            ]
        ], { model: [
                0,
                'model'
            ]
        }, { update: 'ngModelChange' }),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵprd */](1024, null, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["h" /* NgControl */], null, [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["g" /* NgModel */]]),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["i" /* NgControlStatus */], [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["h" /* NgControl */]], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'button', [], [[
                8,
                'disabled',
                0
            ]
        ], [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            var co = v.component;
            if (('click' === en)) {
                co.add(co.name);
                var pd_0 = ((co.name = '') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Add'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'h3', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Players'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 9, 'div', [[
                'class',
                'list'
            ]
        ], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_PlayersComponent_1)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_4__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_PlayersComponent_2)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](401408, null, 0, __WEBPACK_IMPORTED_MODULE_4__angular_common__["n" /* NgForOf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["w" /* IterableDiffers */]
        ], {
            ngForOf: [
                0,
                'ngForOf'
            ],
            ngForTrackBy: [
                1,
                'ngForTrackBy'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_4__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_7 = co.name;
        ck(v, 13, 0, currVal_7);
        var tmp_9_0 = null;
        var currVal_9 = !(((tmp_9_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 26, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 27).transform(co.players))) == null) ? null : tmp_9_0.length);
        ck(v, 26, 0, currVal_9);
        var currVal_10 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 30, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 31).transform(co.players));
        var currVal_11 = co.trackById;
        ck(v, 30, 0, currVal_10, currVal_11);
    }, function (ck, v) {
        var co = v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassUntouched;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassTouched;
        var currVal_2 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassPristine;
        var currVal_3 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassDirty;
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassValid;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassInvalid;
        var currVal_6 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 15).ngClassPending;
        ck(v, 10, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = !((co.name == null) ? null : co.name.length);
        ck(v, 16, 0, currVal_8);
    });
}
function View_PlayersComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'ept-players', [], null, null, null, View_PlayersComponent_0, RenderType_PlayersComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](57344, null, 0, __WEBPACK_IMPORTED_MODULE_2__app_tournament_players_players_component__["a" /* PlayersComponent */], [__WEBPACK_IMPORTED_MODULE_5__ngrx_store_src_store__["a" /* Store */]], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var PlayersComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_29" /* ɵccf */]('ept-players', __WEBPACK_IMPORTED_MODULE_2__app_tournament_players_players_component__["a" /* PlayersComponent */], View_PlayersComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=players.component.ngfactory.js.map

/***/ }),

/***/ "I003":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("dYKZ");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RemoveAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResetLivesAction; });

var ActionTypes = {
    ADD: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* type */])('players/add'),
    REMOVE: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* type */])('players/remove'),
    RESET_LIVES: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* type */])('players/reset-lives'),
};
var AddAction = (function () {
    function AddAction(payload) {
        this.payload = payload;
        this.type = ActionTypes.ADD;
    }
    return AddAction;
}());

var RemoveAction = (function () {
    function RemoveAction(payload) {
        this.payload = payload;
        this.type = ActionTypes.REMOVE;
    }
    return RemoveAction;
}());

var ResetLivesAction = (function () {
    function ResetLivesAction(payload) {
        this.payload = payload;
        this.type = ActionTypes.RESET_LIVES;
    }
    return ResetLivesAction;
}());

//# sourceMappingURL=players.actions.js.map

/***/ }),

/***/ "Iksp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());

//# sourceMappingURL=app.module.js.map

/***/ }),

/***/ "OE5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['header[_ngcontent-%COMP%]{height:60px;line-height:58px;position:absolute;top:0;width:100%;background:#fcfcfc;padding:0 20px;border-bottom:1px solid #eee;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin:0;-webkit-box-flex:1;-ms-flex:1;flex:1;font-weight:300}header[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%], header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] + .post-hidden[_ngcontent-%COMP%]{display:none}header[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%] + .post-hidden[_ngcontent-%COMP%]{display:initial}header[_ngcontent-%COMP%]   .restart[_ngcontent-%COMP%]{margin-right:20px}content[_ngcontent-%COMP%]{position:absolute;top:60px;bottom:0;width:100%;padding:20px;overflow:auto;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:500px){header[_ngcontent-%COMP%]{height:50px;line-height:45px;display:block;text-align:center}header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{display:none}content[_ngcontent-%COMP%]{top:50px}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwLyt0b3VybmFtZW50L3RvdXJuYW1lbnQuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvUGVkcm8tdmsvZXh0cmVtZS1waW5ncG9uZy10b3VybmFtZW50L3NyYy9hcHAvK3RvdXJuYW1lbnQvdG91cm5hbWVudC5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=tournament.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ "SRum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[_nghost-%COMP%]{margin:auto}.game[_ngcontent-%COMP%], .leaderboard[_ngcontent-%COMP%]{margin:40px}.no-players[_ngcontent-%COMP%]{color:#999;font-size:34px;font-weight:300}.playing[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;margin:auto;width:440px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]{width:190px;text-align:center}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{font-size:20px;color:#333;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .lives[_ngcontent-%COMP%], .playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]{width:60px;display:inline-block;vertical-align:middle;padding:10px 0;color:#666}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .lives[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%], .playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{color:#999}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]{font-size:20px}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:20px;vertical-align:middle;position:relative;top:-2px}.playing[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .lives[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:12px}.playing[_ngcontent-%COMP%]   .player-n0[_ngcontent-%COMP%]{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.playing[_ngcontent-%COMP%]   .player-n1[_ngcontent-%COMP%]{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.playing[_ngcontent-%COMP%]   .vs[_ngcontent-%COMP%]{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;color:#999;font-size:30px;font-weight:300;width:40px;text-align:center}.queue[_ngcontent-%COMP%]{text-align:center;padding-top:30px}.queue[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#999;padding-bottom:10px}.queue[_ngcontent-%COMP%]   .next-player[_ngcontent-%COMP%]{padding:4px 0}.leaderboard[_ngcontent-%COMP%]{width:320px;text-align:left;margin:auto}.leaderboard[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{border-bottom:1px solid #ccc;padding-bottom:4px;margin-bottom:6px;font-size:20px;color:#333}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:4px 0}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;line-height:22px}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{width:30px;text-align:center;font-size:20px;color:#666;line-height:20px}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1;flex:1;padding-left:10px;font-size:18px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]{font-size:18px;padding:0 16px;color:#333}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .victories[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;vertical-align:middle;position:relative;top:-2px;color:#999;margin-right:2px}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .lives[_ngcontent-%COMP%]{width:60px;color:#666}.leaderboard[_ngcontent-%COMP%]   .player[_ngcontent-%COMP%]   .lives[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:12px;line-height:20px}@media (min-width:1100px){[_nghost-%COMP%]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.leaderboard[_ngcontent-%COMP%]{margin:40px}}@media (max-width:500px){[_nghost-%COMP%]{width:100%}.game[_ngcontent-%COMP%], .leaderboard[_ngcontent-%COMP%]{margin:40px 0}.playing[_ngcontent-%COMP%]{width:100%}.playing[_ngcontent-%COMP%]   .vs[_ngcontent-%COMP%]{font-size:18px;width:20px}.queue[_ngcontent-%COMP%]   .next-player[_ngcontent-%COMP%]{display:none}.queue[_ngcontent-%COMP%]   .next-player[_ngcontent-%COMP%]:nth-child(-n+4){display:block}.queue[_ngcontent-%COMP%]   .next-player[_ngcontent-%COMP%]:nth-child(3){opacity:.7}.queue[_ngcontent-%COMP%]   .next-player[_ngcontent-%COMP%]:nth-child(4){opacity:.4}.leaderboard[_ngcontent-%COMP%]{width:100%}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwLyt0b3VybmFtZW50L2dhbWUvZ2FtZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9QZWRyby12ay9leHRyZW1lLXBpbmdwb25nLXRvdXJuYW1lbnQvc3JjL2FwcC8rdG91cm5hbWVudC9nYW1lL2dhbWUuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=game.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ "W7JY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_players_actions__ = __webpack_require__("I003");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_queue_actions__ = __webpack_require__("aJWP");
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPlayerEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPlayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPlayersByVictories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isPlaying; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


;
var initialState = {
    ids: [],
    entities: {},
    queue: [],
    playing: [undefined, undefined],
    isPlaying: false,
};
function reducer(state, action) {
    if (state === void 0) { state = __assign({}, initialState); }
    switch (action.type) {
        // Add/Remove/Update players
        case __WEBPACK_IMPORTED_MODULE_0__actions_players_actions__["a" /* ActionTypes */].ADD: {
            var player = action.payload;
            return state.ids.indexOf(player.id) !== -1 ? state : __assign({}, state, { ids: state.ids.concat([player.id]), entities: __assign({}, state.entities, (_a = {}, _a[player.id] = resetPlayer(player), _a)) });
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_players_actions__["a" /* ActionTypes */].REMOVE: {
            var player_1 = action.payload;
            var newEntites = __assign({}, state.entities);
            delete newEntites[player_1.id];
            return state.ids.indexOf(player_1.id) === -1 ? state : __assign({}, state, { ids: state.ids.filter(function (id) { return id !== player_1.id; }), entities: newEntites });
        }
        // When a match is finished
        case __WEBPACK_IMPORTED_MODULE_1__actions_queue_actions__["a" /* ActionTypes */].RESULT: {
            var winner = action.payload.winner;
            var loser = action.payload.loser;
            var playing = state.playing.slice();
            var queue_1 = state.queue.concat([loser.id]);
            var isPlaying_1 = true;
            if (playing[0] === undefined || playing[1] === undefined) {
                console.warn('Queue not shuffled');
                return state;
            }
            winner = __assign({}, state.entities[winner.id]);
            loser = __assign({}, state.entities[loser.id]);
            if (winner.lives !== 0) {
                winner.victories++;
            }
            if (loser.lives !== 0) {
                loser.lives--;
            }
            var nextPlayerId = queue_1[0];
            if (!winner.lives) {
                var nextAlive = queue_1
                    .map(function (id) { return state.entities[id]; })
                    .find(function (player) { return !!player.lives; });
                if (nextAlive.id === loser.id && !loser.lives) {
                    isPlaying_1 = false;
                    queue_1.pop(); // Remove the added last player
                }
                else {
                    var nextAliveId = state.queue.indexOf(nextAlive.id);
                    playing[playing.indexOf(loser.id)] = queue_1.splice(nextAliveId, 1).pop();
                    queue_1.push.apply(queue_1, queue_1.splice(0, nextAliveId));
                }
            }
            else {
                playing[playing.indexOf(loser.id)] = queue_1.splice(0, 1).pop();
            }
            return state.ids.indexOf(winner.id) === -1 || state.ids.indexOf(loser.id) === -1 ? state : __assign({}, state, { entities: __assign({}, state.entities, (_b = {}, _b[winner.id] = winner, _b[loser.id] = loser, _b)), queue: queue_1,
                playing: playing,
                isPlaying: isPlaying_1 });
        }
        // Reset lives
        case __WEBPACK_IMPORTED_MODULE_0__actions_players_actions__["a" /* ActionTypes */].RESET_LIVES: {
            var lives_1 = +action.payload;
            return __assign({}, state, { entities: Object.values(state.entities)
                    .map(function (player) { return (__assign({}, player, { lives: lives_1, initialLives: lives_1, victories: 0 })); })
                    .reduce(function (accPlayers, player) {
                    return (__assign({}, accPlayers, (_a = {}, _a[player.id] = player, _a)));
                    var _a;
                }, {}) });
        }
        // Mix the queue
        case __WEBPACK_IMPORTED_MODULE_1__actions_queue_actions__["a" /* ActionTypes */].SHUFFLE: {
            var queue_2 = Object.values(state.entities)
                .map(function (player) { return player.id; });
            if (queue_2.length < 3) {
                console.warn('Queue needs 3 or more players');
                return __assign({}, state, { isPlaying: false });
            }
            var shuffledQueue = [];
            do {
                var randomIndex = Math.floor(Math.random() * queue_2.length);
                shuffledQueue.push(queue_2.splice(randomIndex, 1).pop());
            } while (queue_2.length);
            return __assign({}, state, { isPlaying: true, playing: shuffledQueue.slice(0, 2), queue: shuffledQueue.slice(2) });
        }
        default: {
            return state;
        }
    }
    var _a, _b;
}
function resetPlayer(_a) {
    var id = _a.id, name = _a.name;
    return {
        id: id || Math.random().toString(36).substr(2, 10),
        name: name,
        lives: 0,
        initialLives: 0,
        victories: 0,
    };
}
// Players
var getPlayerEntities = function (state) { return state.entities; };
var getPlayers = function (state) { return Object.values(state.entities); };
var getPlayersByVictories = function (state) {
    return Object.values(state.entities)
        .sort(function (a, b) {
        if (a.victories === b.victories) {
            return b.lives - a.lives;
        }
        return b.victories - a.victories;
    });
};
// Queue
var getQueue = function (state) { return state.queue; };
var getPlaying = function (state) { return state.playing; };
var isPlaying = function (state) { return state.isPlaying; };
//# sourceMappingURL=players-queue.reducer.js.map

/***/ }),

/***/ "XXEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_players_actions__ = __webpack_require__("I003");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_queue_actions__ = __webpack_require__("aJWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__("3pbj");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TournamentComponent; });





var TournamentComponent = (function () {
    function TournamentComponent(store) {
        this.store = store;
    }
    TournamentComponent.prototype.ngOnInit = function () {
        this.canRestart = this.store
            .select(__WEBPACK_IMPORTED_MODULE_4__reducers__["b" /* getPlayersList */])
            .map(function (queue) { return queue.length >= 3; });
    };
    TournamentComponent.prototype.startTournament = function () {
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_3__actions_queue_actions__["b" /* ShuffleAction */]());
        this.store.dispatch(new __WEBPACK_IMPORTED_MODULE_2__actions_players_actions__["d" /* ResetLivesAction */](3));
    };
    TournamentComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["b" /* Store */] }]; };
    return TournamentComponent;
}());

//# sourceMappingURL=tournament.component.js.map

/***/ }),

/***/ "YWx4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
var AppComponent = (function () {
    function AppComponent() {
    }
    AppComponent.prototype.ngOnInit = function () {
        this.getGithubRepositoryUrl();
    };
    AppComponent.prototype.getGithubRepositoryUrl = function () {
        try {
            var packageInfo = __webpack_require__("7YgM");
            this.githubRepositoryUrl = packageInfo.repository.url;
            this.projectVersion = packageInfo.version;
            this.projectAuthor = packageInfo.author.split(' <')[0];
        }
        catch (e) { }
    };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map

/***/ }),

/***/ "aJWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("dYKZ");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShuffleAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResultAction; });

var ActionTypes = {
    SHUFFLE: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* type */])('queue/shuffle'),
    RESULT: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* type */])('queue/result'),
};
var ShuffleAction = (function () {
    function ShuffleAction(payload) {
        this.payload = payload;
        this.type = ActionTypes.SHUFFLE;
    }
    return ShuffleAction;
}());

var ResultAction = (function () {
    function ResultAction(winner, loser) {
        this.type = ActionTypes.RESULT;
        this.payload = { winner: winner, loser: loser };
    }
    return ResultAction;
}());

//# sourceMappingURL=queue.actions.js.map

/***/ }),

/***/ "be88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[_nghost-%COMP%]{position:fixed;top:140px;left:0;right:0;bottom:0;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto}.warn[_ngcontent-%COMP%]{text-align:center;padding:20px;margin:auto;margin-bottom:0;color:#555}.align[_ngcontent-%COMP%]{display:table;margin:auto;border:1px solid #eee;border-radius:2px;width:300px;margin-top:0}.align[_ngcontent-%COMP%] > div[_ngcontent-%COMP%], .align[_ngcontent-%COMP%] > h3[_ngcontent-%COMP%]{padding:10px 20px}.align[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}.align[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:0 10px;outline:0}.align[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]{max-height:200px;border-top:1px solid #eee;overflow:auto}.align[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.align[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   .no-players[_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-bottom:12px;font-size:16px;color:#999;width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwLyt0b3VybmFtZW50L3BsYXllcnMvcGxheWVycy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9QZWRyby12ay9leHRyZW1lLXBpbmdwb25nLXRvdXJuYW1lbnQvc3JjL2FwcC8rdG91cm5hbWVudC9wbGF5ZXJzL3BsYXllcnMuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=players.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ "dYKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = type;
// https://github.com/ngrx/example-app/blob/master/src/app/util.ts
/**
 * This function coerces a string into a string literal type.
 * Using tagged union types in TypeScript 2.0, this enables
 * powerful typechecking of our reducers.
 *
 * Since every action label passes through this function it
 * is a good place to ensure all of our action labels
 * are unique.
 */
var typeCache = {};
function type(label) {
    if (typeCache[label]) {
        throw new Error("Action type \"" + label + "\" is not unique\"");
    }
    typeCache[label] = true;
    return label;
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "kZql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
var environment = {
    production: true,
    useHash: false,
};
//# sourceMappingURL=environment.js.map

/***/ }),

/***/ "kke6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app_module__ = __webpack_require__("Iksp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__("NVOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_app_routing_module__ = __webpack_require__("Cd9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__ = __webpack_require__("cPow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ngrx_store_src_dispatcher__ = __webpack_require__("osFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tournament_tournament_component_ngfactory__ = __webpack_require__("x8dX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tournament_game_game_component_ngfactory__ = __webpack_require__("FC2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tournament_players_players_component_ngfactory__ = __webpack_require__("FOiB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_component_ngfactory__ = __webpack_require__("1A80");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_tournament_tournament_component__ = __webpack_require__("XXEX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_tournament_game_game_component__ = __webpack_require__("4CF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_tournament_players_players_component__ = __webpack_require__("B4B6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_reducers_index__ = __webpack_require__("3pbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ngrx_store_src_reducer__ = __webpack_require__("oi6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__ = __webpack_require__("NPiC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ngrx_store_src_store__ = __webpack_require__("Zcpd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModuleNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





















var AppModuleInjector = (function (_super) {
    __extends(AppModuleInjector, _super);
    function AppModuleInjector(parent) {
        return _super.call(this, parent, [
            __WEBPACK_IMPORTED_MODULE_10__tournament_tournament_component_ngfactory__["a" /* TournamentComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_11__tournament_game_game_component_ngfactory__["a" /* GameComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_12__tournament_players_players_component_ngfactory__["a" /* PlayersComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_13__app_component_ngfactory__["a" /* AppComponentNgFactory */]
        ], [__WEBPACK_IMPORTED_MODULE_13__app_component_ngfactory__["a" /* AppComponentNgFactory */]]) || this;
    }
    Object.defineProperty(AppModuleInjector.prototype, "_LOCALE_ID_27", {
        get: function () {
            if ((this.__LOCALE_ID_27 == null)) {
                (this.__LOCALE_ID_27 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["b" /* ɵn */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */], null)));
            }
            return this.__LOCALE_ID_27;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_NgLocalization_28", {
        get: function () {
            if ((this.__NgLocalization_28 == null)) {
                (this.__NgLocalization_28 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* NgLocaleLocalization */](this._LOCALE_ID_27));
            }
            return this.__NgLocalization_28;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_APP_ID_29", {
        get: function () {
            if ((this.__APP_ID_29 == null)) {
                (this.__APP_ID_29 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵg */]());
            }
            return this.__APP_ID_29;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_IterableDiffers_30", {
        get: function () {
            if ((this.__IterableDiffers_30 == null)) {
                (this.__IterableDiffers_30 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ɵl */]());
            }
            return this.__IterableDiffers_30;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_KeyValueDiffers_31", {
        get: function () {
            if ((this.__KeyValueDiffers_31 == null)) {
                (this.__KeyValueDiffers_31 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ɵm */]());
            }
            return this.__KeyValueDiffers_31;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_DomSanitizer_32", {
        get: function () {
            if ((this.__DomSanitizer_32 == null)) {
                (this.__DomSanitizer_32 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["b" /* ɵe */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__DomSanitizer_32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Sanitizer_33", {
        get: function () {
            if ((this.__Sanitizer_33 == null)) {
                (this.__Sanitizer_33 = this._DomSanitizer_32);
            }
            return this.__Sanitizer_33;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_HAMMER_GESTURE_CONFIG_34", {
        get: function () {
            if ((this.__HAMMER_GESTURE_CONFIG_34 == null)) {
                (this.__HAMMER_GESTURE_CONFIG_34 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["d" /* HammerGestureConfig */]());
            }
            return this.__HAMMER_GESTURE_CONFIG_34;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_EVENT_MANAGER_PLUGINS_35", {
        get: function () {
            if ((this.__EVENT_MANAGER_PLUGINS_35 == null)) {
                (this.__EVENT_MANAGER_PLUGINS_35 = [
                    new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["e" /* ɵDomEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["f" /* ɵKeyEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["g" /* ɵHammerGesturesPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */]), this._HAMMER_GESTURE_CONFIG_34)
                ]);
            }
            return this.__EVENT_MANAGER_PLUGINS_35;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_EventManager_36", {
        get: function () {
            if ((this.__EventManager_36 == null)) {
                (this.__EventManager_36 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["h" /* EventManager */](this._EVENT_MANAGER_PLUGINS_35, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* NgZone */])));
            }
            return this.__EventManager_36;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_\u0275DomSharedStylesHost_37", {
        get: function () {
            if ((this.__ɵDomSharedStylesHost_37 == null)) {
                (this.__ɵDomSharedStylesHost_37 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["i" /* ɵDomSharedStylesHost */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__ɵDomSharedStylesHost_37;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_\u0275DomRendererFactory2_38", {
        get: function () {
            if ((this.__ɵDomRendererFactory2_38 == null)) {
                (this.__ɵDomRendererFactory2_38 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["j" /* ɵDomRendererFactory2 */](this._EventManager_36, this._ɵDomSharedStylesHost_37));
            }
            return this.__ɵDomRendererFactory2_38;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_RendererFactory2_39", {
        get: function () {
            if ((this.__RendererFactory2_39 == null)) {
                (this.__RendererFactory2_39 = this._ɵDomRendererFactory2_38);
            }
            return this.__RendererFactory2_39;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_\u0275SharedStylesHost_40", {
        get: function () {
            if ((this.__ɵSharedStylesHost_40 == null)) {
                (this.__ɵSharedStylesHost_40 = this._ɵDomSharedStylesHost_37);
            }
            return this.__ɵSharedStylesHost_40;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Testability_41", {
        get: function () {
            if ((this.__Testability_41 == null)) {
                (this.__Testability_41 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* Testability */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* NgZone */])));
            }
            return this.__Testability_41;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Meta_42", {
        get: function () {
            if ((this.__Meta_42 == null)) {
                (this.__Meta_42 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["k" /* Meta */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Meta_42;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Title_43", {
        get: function () {
            if ((this.__Title_43 == null)) {
                (this.__Title_43 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["l" /* Title */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Title_43;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_\u0275i_44", {
        get: function () {
            if ((this.__ɵi_44 == null)) {
                (this.__ɵi_44 = new __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* ɵi */]());
            }
            return this.__ɵi_44;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_BrowserXhr_45", {
        get: function () {
            if ((this.__BrowserXhr_45 == null)) {
                (this.__BrowserXhr_45 = new __WEBPACK_IMPORTED_MODULE_6__angular_http__["a" /* BrowserXhr */]());
            }
            return this.__BrowserXhr_45;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_ResponseOptions_46", {
        get: function () {
            if ((this.__ResponseOptions_46 == null)) {
                (this.__ResponseOptions_46 = new __WEBPACK_IMPORTED_MODULE_6__angular_http__["b" /* BaseResponseOptions */]());
            }
            return this.__ResponseOptions_46;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_XSRFStrategy_47", {
        get: function () {
            if ((this.__XSRFStrategy_47 == null)) {
                (this.__XSRFStrategy_47 = __WEBPACK_IMPORTED_MODULE_6__angular_http__["c" /* ɵb */]());
            }
            return this.__XSRFStrategy_47;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_XHRBackend_48", {
        get: function () {
            if ((this.__XHRBackend_48 == null)) {
                (this.__XHRBackend_48 = new __WEBPACK_IMPORTED_MODULE_6__angular_http__["d" /* XHRBackend */](this._BrowserXhr_45, this._ResponseOptions_46, this._XSRFStrategy_47));
            }
            return this.__XHRBackend_48;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_RequestOptions_49", {
        get: function () {
            if ((this.__RequestOptions_49 == null)) {
                (this.__RequestOptions_49 = new __WEBPACK_IMPORTED_MODULE_6__angular_http__["e" /* BaseRequestOptions */]());
            }
            return this.__RequestOptions_49;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Http_50", {
        get: function () {
            if ((this.__Http_50 == null)) {
                (this.__Http_50 = __WEBPACK_IMPORTED_MODULE_6__angular_http__["f" /* ɵc */](this._XHRBackend_48, this._RequestOptions_49));
            }
            return this.__Http_50;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_ActivatedRoute_51", {
        get: function () {
            if ((this.__ActivatedRoute_51 == null)) {
                (this.__ActivatedRoute_51 = __WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* ɵf */](this._Router_22));
            }
            return this.__ActivatedRoute_51;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_NoPreloading_52", {
        get: function () {
            if ((this.__NoPreloading_52 == null)) {
                (this.__NoPreloading_52 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* NoPreloading */]());
            }
            return this.__NoPreloading_52;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_PreloadingStrategy_53", {
        get: function () {
            if ((this.__PreloadingStrategy_53 == null)) {
                (this.__PreloadingStrategy_53 = this._NoPreloading_52);
            }
            return this.__PreloadingStrategy_53;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_RouterPreloader_54", {
        get: function () {
            if ((this.__RouterPreloader_54 == null)) {
                (this.__RouterPreloader_54 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* RouterPreloader */](this._Router_22, this._NgModuleFactoryLoader_20, this._Compiler_19, this, this._PreloadingStrategy_53));
            }
            return this.__RouterPreloader_54;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_PreloadAllModules_55", {
        get: function () {
            if ((this.__PreloadAllModules_55 == null)) {
                (this.__PreloadAllModules_55 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["d" /* PreloadAllModules */]());
            }
            return this.__PreloadAllModules_55;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_ROUTER_INITIALIZER_56", {
        get: function () {
            if ((this.__ROUTER_INITIALIZER_56 == null)) {
                (this.__ROUTER_INITIALIZER_56 = __WEBPACK_IMPORTED_MODULE_3__angular_router__["e" /* ɵi */](this._ɵg_3));
            }
            return this.__ROUTER_INITIALIZER_56;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_APP_BOOTSTRAP_LISTENER_57", {
        get: function () {
            if ((this.__APP_BOOTSTRAP_LISTENER_57 == null)) {
                (this.__APP_BOOTSTRAP_LISTENER_57 = [this._ROUTER_INITIALIZER_56]);
            }
            return this.__APP_BOOTSTRAP_LISTENER_57;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Dispatcher_58", {
        get: function () {
            if ((this.__Dispatcher_58 == null)) {
                (this.__Dispatcher_58 = new __WEBPACK_IMPORTED_MODULE_9__ngrx_store_src_dispatcher__["a" /* Dispatcher */]());
            }
            return this.__Dispatcher_58;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_INITIAL_REDUCER_60", {
        get: function () {
            if ((this.__INITIAL_REDUCER_60 == null)) {
                (this.__INITIAL_REDUCER_60 = __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["a" /* _initialReducerFactory */](this.__INITIAL_REDUCER_59));
            }
            return this.__INITIAL_REDUCER_60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Reducer_61", {
        get: function () {
            if ((this.__Reducer_61 == null)) {
                (this.__Reducer_61 = __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["b" /* _reducerFactory */](this._Dispatcher_58, this._INITIAL_REDUCER_60));
            }
            return this.__Reducer_61;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_INITIAL_STATE_63", {
        get: function () {
            if ((this.__INITIAL_STATE_63 == null)) {
                (this.__INITIAL_STATE_63 = __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["c" /* _initialStateFactory */](this.__INITIAL_STATE_62, this._INITIAL_REDUCER_60));
            }
            return this.__INITIAL_STATE_63;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_State_64", {
        get: function () {
            if ((this.__State_64 == null)) {
                (this.__State_64 = __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["d" /* _stateFactory */](this._INITIAL_STATE_63, this._Dispatcher_58, this._Reducer_61));
            }
            return this.__State_64;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModuleInjector.prototype, "_Store_65", {
        get: function () {
            if ((this.__Store_65 == null)) {
                (this.__Store_65 = __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["e" /* _storeFactory */](this._Dispatcher_58, this._Reducer_61, this._State_64));
            }
            return this.__Store_65;
        },
        enumerable: true,
        configurable: true
    });
    AppModuleInjector.prototype.createInternal = function () {
        this._CommonModule_0 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */]();
        this._ErrorHandler_1 = __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["m" /* ɵa */]();
        this._NgProbeToken_2 = [__WEBPACK_IMPORTED_MODULE_3__angular_router__["f" /* ɵb */]()];
        this._ɵg_3 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["g" /* ɵg */](this);
        this._APP_INITIALIZER_4 = [
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* ɵo */],
            __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["n" /* ɵc */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["o" /* NgProbeToken */], null), this._NgProbeToken_2),
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["h" /* ɵh */](this._ɵg_3)
        ];
        this._ApplicationInitStatus_5 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* ApplicationInitStatus */](this._APP_INITIALIZER_4);
        this._ɵf_6 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* ɵf */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* NgZone */]), this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["l" /* ɵConsole */]), this, this._ErrorHandler_1, this.componentFactoryResolver, this._ApplicationInitStatus_5);
        this._ApplicationRef_7 = this._ɵf_6;
        this._ApplicationModule_8 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* ApplicationModule */](this._ApplicationRef_7);
        this._BrowserModule_9 = new __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["p" /* BrowserModule */](this.parent.get(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["p" /* BrowserModule */], null));
        this._ɵba_10 = new __WEBPACK_IMPORTED_MODULE_5__angular_forms__["b" /* ɵba */]();
        this._FormsModule_11 = new __WEBPACK_IMPORTED_MODULE_5__angular_forms__["c" /* FormsModule */]();
        this._HttpModule_12 = new __WEBPACK_IMPORTED_MODULE_6__angular_http__["g" /* HttpModule */]();
        this._ɵa_13 = __WEBPACK_IMPORTED_MODULE_3__angular_router__["i" /* ɵd */](this.parent.get(__WEBPACK_IMPORTED_MODULE_3__angular_router__["j" /* Router */], null));
        this._UrlSerializer_14 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["k" /* DefaultUrlSerializer */]();
        this._RouterOutletMap_15 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["l" /* RouterOutletMap */]();
        this._ROUTER_CONFIGURATION_16 = { useHash: false };
        this._LocationStrategy_17 = __WEBPACK_IMPORTED_MODULE_3__angular_router__["m" /* ɵc */](this.parent.get(__WEBPACK_IMPORTED_MODULE_2__angular_common__["c" /* PlatformLocation */]), this.parent.get(__WEBPACK_IMPORTED_MODULE_2__angular_common__["d" /* APP_BASE_HREF */], null), this._ROUTER_CONFIGURATION_16);
        this._Location_18 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["e" /* Location */](this._LocationStrategy_17);
        this._Compiler_19 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* Compiler */]();
        this._NgModuleFactoryLoader_20 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* SystemJsNgModuleLoader */](this._Compiler_19, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["p" /* SystemJsNgModuleLoaderConfig */], null));
        this._ROUTES_21 = [[
                {
                    path: '',
                    component: __WEBPACK_IMPORTED_MODULE_14__app_tournament_tournament_component__["a" /* TournamentComponent */],
                    children: [
                        {
                            path: '',
                            component: __WEBPACK_IMPORTED_MODULE_15__app_tournament_game_game_component__["a" /* GameComponent */]
                        },
                        {
                            path: 'players',
                            component: __WEBPACK_IMPORTED_MODULE_16__app_tournament_players_players_component__["a" /* PlayersComponent */]
                        }
                    ]
                },
                {
                    path: '**',
                    redirectTo: ''
                }
            ]
        ];
        this._Router_22 = __WEBPACK_IMPORTED_MODULE_3__angular_router__["n" /* ɵe */](this._ApplicationRef_7, this._UrlSerializer_14, this._RouterOutletMap_15, this._Location_18, this, this._NgModuleFactoryLoader_20, this._Compiler_19, this._ROUTES_21, this._ROUTER_CONFIGURATION_16, this.parent.get(__WEBPACK_IMPORTED_MODULE_3__angular_router__["o" /* UrlHandlingStrategy */], null), this.parent.get(__WEBPACK_IMPORTED_MODULE_3__angular_router__["p" /* RouteReuseStrategy */], null));
        this._RouterModule_23 = new __WEBPACK_IMPORTED_MODULE_3__angular_router__["q" /* RouterModule */](this._ɵa_13, this._Router_22);
        this._AppRoutingModule_24 = new __WEBPACK_IMPORTED_MODULE_7__app_app_routing_module__["a" /* AppRoutingModule */]();
        this._StoreModule_25 = new __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["f" /* StoreModule */]();
        this._AppModule_26 = new __WEBPACK_IMPORTED_MODULE_1__app_app_module__["a" /* AppModule */]();
        this.__INITIAL_REDUCER_59 = __WEBPACK_IMPORTED_MODULE_17__app_reducers_index__["a" /* reducer */];
        this.__INITIAL_STATE_62 = undefined;
        return this._AppModule_26;
    };
    AppModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */])) {
            return this._CommonModule_0;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["q" /* ErrorHandler */])) {
            return this._ErrorHandler_1;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* NgProbeToken */])) {
            return this._NgProbeToken_2;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["g" /* ɵg */])) {
            return this._ɵg_3;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["s" /* APP_INITIALIZER */])) {
            return this._APP_INITIALIZER_4;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* ApplicationInitStatus */])) {
            return this._ApplicationInitStatus_5;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* ɵf */])) {
            return this._ɵf_6;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["t" /* ApplicationRef */])) {
            return this._ApplicationRef_7;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* ApplicationModule */])) {
            return this._ApplicationModule_8;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["p" /* BrowserModule */])) {
            return this._BrowserModule_9;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5__angular_forms__["b" /* ɵba */])) {
            return this._ɵba_10;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5__angular_forms__["c" /* FormsModule */])) {
            return this._FormsModule_11;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["g" /* HttpModule */])) {
            return this._HttpModule_12;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["r" /* ɵa */])) {
            return this._ɵa_13;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["s" /* UrlSerializer */])) {
            return this._UrlSerializer_14;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["l" /* RouterOutletMap */])) {
            return this._RouterOutletMap_15;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["t" /* ROUTER_CONFIGURATION */])) {
            return this._ROUTER_CONFIGURATION_16;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["f" /* LocationStrategy */])) {
            return this._LocationStrategy_17;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["e" /* Location */])) {
            return this._Location_18;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* Compiler */])) {
            return this._Compiler_19;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* NgModuleFactoryLoader */])) {
            return this._NgModuleFactoryLoader_20;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["u" /* ROUTES */])) {
            return this._ROUTES_21;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["j" /* Router */])) {
            return this._Router_22;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["q" /* RouterModule */])) {
            return this._RouterModule_23;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__app_app_routing_module__["a" /* AppRoutingModule */])) {
            return this._AppRoutingModule_24;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["f" /* StoreModule */])) {
            return this._StoreModule_25;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_1__app_app_module__["a" /* AppModule */])) {
            return this._AppModule_26;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */])) {
            return this._LOCALE_ID_27;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["g" /* NgLocalization */])) {
            return this._NgLocalization_28;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["v" /* APP_ID */])) {
            return this._APP_ID_29;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* IterableDiffers */])) {
            return this._IterableDiffers_30;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* KeyValueDiffers */])) {
            return this._KeyValueDiffers_31;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["q" /* DomSanitizer */])) {
            return this._DomSanitizer_32;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* Sanitizer */])) {
            return this._Sanitizer_33;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["r" /* HAMMER_GESTURE_CONFIG */])) {
            return this._HAMMER_GESTURE_CONFIG_34;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["s" /* EVENT_MANAGER_PLUGINS */])) {
            return this._EVENT_MANAGER_PLUGINS_35;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["h" /* EventManager */])) {
            return this._EventManager_36;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["i" /* ɵDomSharedStylesHost */])) {
            return this._ɵDomSharedStylesHost_37;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["j" /* ɵDomRendererFactory2 */])) {
            return this._ɵDomRendererFactory2_38;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* RendererFactory2 */])) {
            return this._RendererFactory2_39;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["t" /* ɵSharedStylesHost */])) {
            return this._ɵSharedStylesHost_40;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* Testability */])) {
            return this._Testability_41;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["k" /* Meta */])) {
            return this._Meta_42;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["l" /* Title */])) {
            return this._Title_43;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* ɵi */])) {
            return this._ɵi_44;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["a" /* BrowserXhr */])) {
            return this._BrowserXhr_45;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["h" /* ResponseOptions */])) {
            return this._ResponseOptions_46;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["i" /* XSRFStrategy */])) {
            return this._XSRFStrategy_47;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["d" /* XHRBackend */])) {
            return this._XHRBackend_48;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["j" /* RequestOptions */])) {
            return this._RequestOptions_49;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__angular_http__["k" /* Http */])) {
            return this._Http_50;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["v" /* ActivatedRoute */])) {
            return this._ActivatedRoute_51;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* NoPreloading */])) {
            return this._NoPreloading_52;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["w" /* PreloadingStrategy */])) {
            return this._PreloadingStrategy_53;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* RouterPreloader */])) {
            return this._RouterPreloader_54;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["d" /* PreloadAllModules */])) {
            return this._PreloadAllModules_55;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3__angular_router__["x" /* ROUTER_INITIALIZER */])) {
            return this._ROUTER_INITIALIZER_56;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* APP_BOOTSTRAP_LISTENER */])) {
            return this._APP_BOOTSTRAP_LISTENER_57;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__ngrx_store_src_dispatcher__["a" /* Dispatcher */])) {
            return this._Dispatcher_58;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["g" /* _INITIAL_REDUCER */])) {
            return this.__INITIAL_REDUCER_59;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["h" /* INITIAL_REDUCER */])) {
            return this._INITIAL_REDUCER_60;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_18__ngrx_store_src_reducer__["a" /* Reducer */])) {
            return this._Reducer_61;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["i" /* _INITIAL_STATE */])) {
            return this.__INITIAL_STATE_62;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__ngrx_store_src_ng2__["j" /* INITIAL_STATE */])) {
            return this._INITIAL_STATE_63;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__["a" /* State */])) {
            return this._State_64;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_20__ngrx_store_src_store__["a" /* Store */])) {
            return this._Store_65;
        }
        return notFoundResult;
    };
    AppModuleInjector.prototype.destroyInternal = function () {
        this._ɵf_6.ngOnDestroy();
        (this.__ɵDomSharedStylesHost_37 && this._ɵDomSharedStylesHost_37.ngOnDestroy());
        (this.__RouterPreloader_54 && this._RouterPreloader_54.ngOnDestroy());
    };
    return AppModuleInjector;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* ɵNgModuleInjector */]));
var AppModuleNgFactory = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* NgModuleFactory */](AppModuleInjector, __WEBPACK_IMPORTED_MODULE_1__app_app_module__["a" /* AppModule */]);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvUGVkcm8tdmsvZXh0cmVtZS1waW5ncG9uZy10b3VybmFtZW50L3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=
//# sourceMappingURL=app.module.ngfactory.js.map

/***/ }),

/***/ "l0Vc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['header[_ngcontent-%COMP%]{height:80px;line-height:78px;position:fixed;top:0;width:100%;background:#fafafa;padding:0 20px;border-bottom:1px solid #eee;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:300;margin:0;font-size:32px}header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{text-align:right;-webkit-box-flex:1;-ms-flex:1;flex:1;font-size:14px;font-weight:300;color:#666}header[_ngcontent-%COMP%]   .info__item[_ngcontent-%COMP%]{margin:0 6px}header[_ngcontent-%COMP%]   .info__item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-weight:400;color:#333}header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;transition:all .3s ease;cursor:pointer}header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#777}content[_ngcontent-%COMP%]{position:fixed;top:80px;bottom:0;width:100%}@media (max-width:680px){header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:24px}}@media (max-width:570px){header[_ngcontent-%COMP%]{text-align:center;display:block;line-height:40px}header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:24px;height:40px;line-height:48px}header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{text-align:center}}@media (max-width:380px){header[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{font-size:12px}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9QZWRyby12ay9leHRyZW1lLXBpbmdwb25nLXRvdXJuYW1lbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=app.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ "x35b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environments_environment__ = __webpack_require__("kZql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gendir_app_app_module_ngfactory__ = __webpack_require__("kke6");




if (__WEBPACK_IMPORTED_MODULE_1__environments_environment__["a" /* environment */].production) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["a" /* enableProdMode */])();
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register('service-worker.js').then(function (reg) {
                reg.onupdatefound = function () {
                    var installingWorker = reg.installing;
                    installingWorker.onstatechange = function () {
                        switch (installingWorker.state) {
                            case 'installed':
                                if (navigator.serviceWorker.controller) {
                                    console.log('[SW] New or updated content is available.');
                                    window.location.reload(true);
                                }
                                else {
                                    console.log('[SW] Content is now available offline!');
                                }
                                break;
                            case 'redundant':
                                console.error('[SW] The installing servicbe worker became redundant.');
                                break;
                        }
                    };
                };
            }).catch(function (e) {
                console.error('[SW] Error during service worker registration:', e);
            });
        });
    }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["a" /* platformBrowser */])().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_3__gendir_app_app_module_ngfactory__["a" /* AppModuleNgFactory */]);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "x8dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tournament_component_scss_shim_ngstyle__ = __webpack_require__("OE5p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_tournament_tournament_component__ = __webpack_require__("XXEX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ngrx_store_src_store__ = __webpack_require__("Zcpd");
/* unused harmony export RenderType_TournamentComponent */
/* unused harmony export View_TournamentComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TournamentComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_TournamentComponent = [__WEBPACK_IMPORTED_MODULE_0__tournament_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_TournamentComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_24" /* ɵcrt */]({
    encapsulation: 0,
    styles: styles_TournamentComponent,
    data: {}
});
function View_TournamentComponent_1(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'button', [[
                'class',
                'restart'
            ]
        ], null, [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            var co = v.component;
            if (('click' === en)) {
                var pd_0 = (co.startTournament() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Restart tournament']))
    ], null, null);
}
function View_TournamentComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](2, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 19, 'header', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'h2', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n    Tournament\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_32" /* ɵand */](8388608, null, null, 2, null, View_TournamentComponent_1)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["l" /* NgIf */], [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_7" /* TemplateRef */]
        ], { ngIf: [
                0,
                'ngIf'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](65536, __WEBPACK_IMPORTED_MODULE_2__angular_common__["m" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]]),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 5, 'button', [
            [
                'routerLink',
                '/players'
            ],
            [
                'routerLinkActive',
                'hidden'
            ]
        ], null, [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 10).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, [[
                1,
                4
            ]
        ], 0, __WEBPACK_IMPORTED_MODULE_3__angular_router__["z" /* RouterLink */], [
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["j" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["v" /* ActivatedRoute */],
            [
                8,
                null
            ],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["M" /* Renderer */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* ElementRef */]
        ], { routerLink: [
                0,
                'routerLink'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](860160, null, 2, __WEBPACK_IMPORTED_MODULE_3__angular_router__["A" /* RouterLinkActive */], [
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["j" /* Router */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* ElementRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["M" /* Renderer */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["R" /* ChangeDetectorRef */]
        ], { routerLinkActive: [
                0,
                'routerLinkActive'
            ]
        }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](301989888, 1, { links: 1 }),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](301989888, 2, { linksWithHrefs: 1 }),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Edit players'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 2, 'button', [
            [
                'class',
                'post-hidden'
            ],
            [
                'routerLink',
                '/'
            ]
        ], null, [[
                null,
                'click'
            ]
        ], function (v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 17).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](8192, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_router__["z" /* RouterLink */], [
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["j" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["v" /* ActivatedRoute */],
            [
                8,
                null
            ],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["M" /* Renderer */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* ElementRef */]
        ], { routerLink: [
                0,
                'routerLink'
            ]
        }, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['Close'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 4, 'content', [], null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n  '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](8388608, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](73728, null, 0, __WEBPACK_IMPORTED_MODULE_3__angular_router__["y" /* RouterOutlet */], [
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["l" /* RouterOutletMap */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["V" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["W" /* ComponentFactoryResolver */],
            [
                8,
                null
            ]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n'])),
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_27" /* ɵted */](null, ['\n\n']))
    ], function (ck, v) {
        var co = v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_34" /* ɵunv */](v, 6, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_30" /* ɵnov */](v, 7).transform(co.canRestart));
        ck(v, 6, 0, currVal_0);
        var currVal_1 = '/players';
        ck(v, 10, 0, currVal_1);
        var currVal_2 = 'hidden';
        ck(v, 11, 0, currVal_2);
        var currVal_3 = '/';
        ck(v, 17, 0, currVal_3);
    }, null);
}
function View_TournamentComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_25" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_26" /* ɵeld */](0, null, null, 1, 'ept-tournament', [], null, null, null, View_TournamentComponent_0, RenderType_TournamentComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_28" /* ɵdid */](57344, null, 0, __WEBPACK_IMPORTED_MODULE_4__app_tournament_tournament_component__["a" /* TournamentComponent */], [__WEBPACK_IMPORTED_MODULE_5__ngrx_store_src_store__["a" /* Store */]], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var TournamentComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_29" /* ɵccf */]('ept-tournament', __WEBPACK_IMPORTED_MODULE_4__app_tournament_tournament_component__["a" /* TournamentComponent */], View_TournamentComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=tournament.component.ngfactory.js.map

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.d64f2f6e48d33d58d8ae.bundle.js